import React, { useEffect, useState, useRef } from 'react'; 
import CoupanList from '../../views/PartnerView/CoupanList'; 
import { useParams } from 'react-router-dom'; 
import { useServiceContext } from '../Context/ServiceContext';
 import Coupansedit from '../../views/PartnerView/ViewCoupans'; 
 const PartnerCoupanListComponent = () => { 
    const userType = localStorage.getItem('userType'); 
    const [loading, setLoading] = useState(true); 
    const didFetch = useRef(false);
    const { id, edit } = useParams();
    const [CoupanData, setCoupanData] = useState(null);
    const { getallcouponpartner } = useServiceContext(); 
    const getData = async () => { 
        try { 
            let data; 
                if (userType === 'ADMIN') { 
                // Fetch data for ADMIN if required 
                } else { 
                    data = await getallcouponpartner();
                } 
                setCoupanData(data); 
                setLoading(false); 
            } catch (error) { 
                console.log('Error fetching data:', error.response?.data);
                 setLoading(false); 
            } 
    }; 
    useEffect(() => { 
        if (!didFetch.current) 
            { 
                getData();
                didFetch.current = true;
            } 
            console.log(CoupanData);
    }, [CoupanData]);
        return (
            
             <div> {!loading && <CoupanList />} </div> ); 

    }; 
export default PartnerCoupanListComponent;